export default "__VITE_ASSET__hcYX0tZC__"